import { TypographyProps } from '@global-engineering-shared/gweb-material-types';
import { Box, Typography } from '@global-engineering-shared/gweb-material-ui';

import SearchBar from 'components/SearchBar';
import useStyles from 'components/TablePageHeader/TablePageHeader.styles';
import { useFilters } from 'context/FilterProvider/FilterProvider';
import Filter from 'features/Filters/Filter';
import FilterChipsContainer from 'features/Filters/FilterChipsContainer/FilterChipsContainer';
import { Filter as FilterType } from 'features/Filters/types/Filters';
import { areFiltersDefault } from 'features/Filters/utils/areFiltersDefault';
import ImportButton from 'features/Import/components/ImportButton';

type TablePageHeaderProps = {
  title: string | React.ReactNode;
  titleVariant?: TypographyProps['variant'];
  titleFontWeight?: number;
  showSearchBar?: boolean;
  showImport?: boolean;
  filterValues?: FilterType[];
  children?: React.ReactNode;
};

const TablePageHeader = ({
  title,
  titleVariant = 'h3',
  titleFontWeight = 700,
  showSearchBar = true,
  showImport = true,
  filterValues,
  children,
}: TablePageHeaderProps) => {
  const classes = useStyles();
  const { filters } = useFilters();

  return (
    <Box className={classes.root}>
      <Box className={classes.headerContainer}>{showSearchBar && <SearchBar />}</Box>
      {!areFiltersDefault(filters) && <FilterChipsContainer />}
      <Box className={classes.titleButtonContainer}>
        <Typography variant={titleVariant} fontWeight={titleFontWeight}>
          {title}
        </Typography>
        <Box className={classes.buttonsContainer}>
          {filterValues && <Filter filterValues={filterValues} />}
          {showImport && <ImportButton />}
        </Box>
      </Box>
      {children}
    </Box>
  );
};

export default TablePageHeader;
